export enum DisplayNavigationRoutes {
  WaitingRoom = 'waiting-room',
  ContestInProgress = 'contest-in-progress',
  Results = 'results',
  Tournaments = '/tournaments',
  TournamentsWithLocationName = '/tournaments/:locationName',
}
